var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "db-demo" }, [
    _c(
      "aside",
      { staticClass: "db-demo__sidebar" },
      [
        _c("h5", { staticClass: "db-demo__title" }, [
          _vm._v("Document Builder — Demo")
        ]),
        _c("label", { staticClass: "db-demo__label" }, [
          _vm._v("Nombre del documento")
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.docName,
              expression: "docName"
            }
          ],
          staticClass: "db-demo__input",
          attrs: { type: "text", placeholder: "Nombre del documento" },
          domProps: { value: _vm.docName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.docName = $event.target.value
            }
          }
        }),
        _c("label", { staticClass: "db-demo__label" }, [
          _vm._v("Importar HTML")
        ]),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.htmlInput,
              expression: "htmlInput"
            }
          ],
          staticClass: "db-demo__textarea",
          attrs: {
            rows: "5",
            placeholder: "Pega aquí el HTML del documento..."
          },
          domProps: { value: _vm.htmlInput },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.htmlInput = $event.target.value
            }
          }
        }),
        _c(
          "b-button",
          {
            staticClass: "db-demo__import-btn",
            attrs: {
              size: "sm",
              variant: "primary",
              disabled: !_vm.htmlInput.trim()
            },
            on: { click: _vm.openImportModal }
          },
          [_vm._v(" Importar HTML al lienzo ")]
        ),
        _c(
          "b-modal",
          {
            attrs: { title: "Importar HTML", centered: "", "hide-footer": "" },
            model: {
              value: _vm.showImportModal,
              callback: function($$v) {
                _vm.showImportModal = $$v
              },
              expression: "showImportModal"
            }
          },
          [
            _c("p", { staticClass: "db-demo__modal-text" }, [
              _vm._v(
                " ¿Qué quieres hacer con los estilos (CSS) al importar este HTML? "
              )
            ]),
            _c(
              "div",
              { staticClass: "db-demo__modal-actions" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.confirmImport("merge")
                      }
                    }
                  },
                  [
                    _vm._v(" Fusionar "),
                    _c("small", { staticClass: "db-demo__modal-hint" }, [
                      _vm._v(
                        " Combina el CSS actual con el del HTML importado "
                      )
                    ])
                  ]
                ),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "outline-primary" },
                    on: {
                      click: function($event) {
                        return _vm.confirmImport("replace")
                      }
                    }
                  },
                  [
                    _vm._v(" Reemplazar "),
                    _c("small", { staticClass: "db-demo__modal-hint" }, [
                      _vm._v(" Usa solo el CSS del HTML importado ")
                    ])
                  ]
                ),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "outline-primary" },
                    on: {
                      click: function($event) {
                        return _vm.confirmImport("keep")
                      }
                    }
                  },
                  [
                    _vm._v(" Mantener "),
                    _c("small", { staticClass: "db-demo__modal-hint" }, [
                      _vm._v(" Conserva el CSS actual e ignora el del HTML ")
                    ])
                  ]
                )
              ],
              1
            )
          ]
        ),
        _c("label", { staticClass: "db-demo__label" }, [
          _vm._v("Tamaño de página")
        ]),
        _c(
          "div",
          { staticClass: "db-demo__sizes" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  size: "sm",
                  variant:
                    _vm.currentPageSize === "A4" ? "primary" : "outline-primary"
                },
                on: {
                  click: function($event) {
                    return _vm.setPageSize("A4")
                  }
                }
              },
              [_vm._v(" A4 ")]
            ),
            _c(
              "b-button",
              {
                attrs: {
                  size: "sm",
                  variant:
                    _vm.currentPageSize === "CARTA"
                      ? "primary"
                      : "outline-primary"
                },
                on: {
                  click: function($event) {
                    return _vm.setPageSize("CARTA")
                  }
                }
              },
              [_vm._v(" Carta ")]
            )
          ],
          1
        ),
        _c("label", { staticClass: "db-demo__label" }, [_vm._v("Acciones")]),
        _c(
          "div",
          { staticClass: "db-demo__actions" },
          [
            _c(
              "b-button",
              {
                attrs: { size: "sm", variant: "outline-primary" },
                on: { click: _vm.exportHtml }
              },
              [_vm._v(" Exportar HTML ")]
            ),
            _c(
              "b-button",
              {
                attrs: { size: "sm", variant: "outline-success" },
                on: { click: _vm.saveJson }
              },
              [_vm._v(" Guardar JSON ")]
            ),
            _c(
              "b-button",
              {
                attrs: {
                  size: "sm",
                  variant: "outline-warning",
                  disabled: !_vm.savedJson
                },
                on: { click: _vm.loadJson }
              },
              [_vm._v(" Cargar JSON ")]
            ),
            _c(
              "b-button",
              {
                attrs: { size: "sm", variant: "outline-info" },
                on: { click: _vm.openCodeModal }
              },
              [_vm._v(" Editar código (HTML/CSS) ")]
            ),
            _c(
              "b-button",
              {
                attrs: { size: "sm", variant: "outline-dark" },
                on: { click: _vm.printA4 }
              },
              [_vm._v(" Imprimir / Preview A4 ")]
            )
          ],
          1
        ),
        _c("label", { staticClass: "db-demo__label" }, [
          _vm._v("Salida (HTML/CSS o JSON del proyecto)")
        ]),
        _c("pre", { staticClass: "db-demo__json" }, [
          _vm._v(_vm._s(_vm.projectJson))
        ]),
        _c(
          "b-modal",
          {
            attrs: {
              title: "Editor de código",
              size: "xl",
              centered: "",
              "ok-title": "Aplicar",
              "cancel-title": "Cancelar"
            },
            on: { ok: _vm.applyCode },
            model: {
              value: _vm.showCodeModal,
              callback: function($$v) {
                _vm.showCodeModal = $$v
              },
              expression: "showCodeModal"
            }
          },
          [
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  { attrs: { title: "HTML", active: "" } },
                  [
                    _c("CodeEditor", {
                      model: {
                        value: _vm.codeHtml,
                        callback: function($$v) {
                          _vm.codeHtml = $$v
                        },
                        expression: "codeHtml"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "b-tab",
                  { attrs: { title: "CSS" } },
                  [
                    _c("CodeEditor", {
                      model: {
                        value: _vm.codeCss,
                        callback: function($$v) {
                          _vm.codeCss = $$v
                        },
                        expression: "codeCss"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "b-modal",
          {
            attrs: {
              title: "Editar HTML del componente",
              size: "xl",
              centered: "",
              "ok-title": "Aplicar",
              "cancel-title": "Cancelar"
            },
            on: { ok: _vm.applyComponentCode },
            model: {
              value: _vm.showComponentCodeModal,
              callback: function($$v) {
                _vm.showComponentCodeModal = $$v
              },
              expression: "showComponentCodeModal"
            }
          },
          [
            _c("CodeEditor", {
              model: {
                value: _vm.componentHtml,
                callback: function($$v) {
                  _vm.componentHtml = $$v
                },
                expression: "componentHtml"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "main",
      { staticClass: "db-demo__main" },
      [
        _c("GrapesDocEditor", {
          ref: "editor",
          attrs: { "initial-page-size": _vm.currentPageSize },
          on: { "edit-component-code": _vm.openComponentCodeModal }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }